import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';
import { DcIcons } from 'src/app/ui/app-dc.icons';

export enum MapAction {
	Delete = 'delete',
}

export interface IMapActionModalData {
	mapId: number | Array<number>;
	element: string;
	action: MapAction;
}

@Component({
	selector: 'app-map-action-popup',
	templateUrl: './map-action-popup.component.html',
	styleUrls: ['./map-action-popup.component.scss'],
})
export class MapActionPopupComponent<T extends IMapActionModalData>
	extends DcBaseComponent
	implements OnInit
{
	public vo$!: Observable<{
		element: string;
		mapId: number | Array<number>;
		isMultipleElement: boolean;
		action: MapAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly MapAction = MapAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'map-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.mapId) && this.modalData.element === '',
			mapId: this.modalData.mapId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
